import { __assign } from "tslib";
import * as React from 'react';
function IconEyeSizeXs(props) {
    return (React.createElement("svg", __assign({ viewBox: "0 0 12 12" }, props),
        React.createElement("path", { d: "M6 2C3.273 2 .944 3.659 0 6c.944 2.341 3.273 4 6 4s5.056-1.659 6-4c-.944-2.341-3.273-4-6-4zm0 6.667C4.495 8.667 3.273 7.472 3.273 6c0-1.472 1.222-2.667 2.727-2.667S8.727 4.528 8.727 6c0 1.472-1.222 2.667-2.727 2.667zM6 4.4c-.905 0-1.636.715-1.636 1.6 0 .885.73 1.6 1.636 1.6.905 0 1.636-.715 1.636-1.6 0-.885-.73-1.6-1.636-1.6z" })));
}
export default IconEyeSizeXs;
